// src/services/eventCastServices.js
import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/events`;
const token = localStorage.getItem("token");

const authHeaders = () => ({
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

/// GET
// Bundle complet : event + mats + slots + messages + state
export const getEventCastBundle = async (eventId) => {
  try {
    const res = await axios.get(`${apiUrl}/${eventId}/cast`, authHeaders());
    return res.data;
  } catch (error) {
    console.error("getEventCastBundle error:", error);
  }
};

// Messages seulement
export const getEventCastMessages = async (eventId) => {
  try {
    const res = await axios.get(
      `${apiUrl}/${eventId}/cast/messages`,
      authHeaders()
    );
    return res.data;
  } catch (error) {
    console.error("getEventCastMessages error:", error);
  }
};

/// PUT
// Upsert d’un tapis + slots (remplacement complet des slots)
// payload attendu : { label, is_open, sort_order, slots:[{slot_index,label,note,is_active}] }
export const upsertEventMatWithSlots = async (eventId, matNumber, payload) => {
  try {
    const res = await axios.put(
      `${apiUrl}/${eventId}/cast/mats/${matNumber}`,
      payload,
      authHeaders()
    );
    return res.data;
  } catch (error) {
    console.error("upsertEventMatWithSlots error:", error);
  }
};

// Toggle tapis ouvert/fermé
export const toggleEventMatOpen = async (eventId, matNumber) => {
  try {
    const res = await axios.put(
      `${apiUrl}/${eventId}/cast/mats/${matNumber}/toggle`,
      {},
      authHeaders()
    );
    return res.data;
  } catch (error) {
    console.error("toggleEventMatOpen error:", error);
  }
};

// Cast state (mode + active_message_id)
// payload : { mode:"MATS"|"MESSAGE", active_message_id:null|id, updated_by_user_id }
export const upsertEventCastState = async (eventId, payload) => {
  try {
    const res = await axios.put(
      `${apiUrl}/${eventId}/cast/state`,
      payload,
      authHeaders()
    );
    return res.data;
  } catch (error) {
    console.error("upsertEventCastState error:", error);
  }
};

/// POST
// Ajouter un message
// payload : { type,title,content,target_mat_number,severity,is_pinned,is_active,starts_at,ends_at }
export const createEventCastMessage = async (eventId, payload) => {
  try {
    const res = await axios.post(
      `${apiUrl}/${eventId}/cast/messages/add`,
      payload,
      authHeaders()
    );
    return res.data;
  } catch (error) {
    console.error("createEventCastMessage error:", error);
  }
};

/// PUT
// Modifier un message
export const updateEventCastMessage = async (eventId, message) => {
  try {
    const res = await axios.put(
      `${apiUrl}/${eventId}/cast/messages/update/${message.id}`,
      message,
      authHeaders()
    );
    return res.data;
  } catch (error) {
    console.error("updateEventCastMessage error:", error);
  }
};

// Toggle message actif/inactif
export const toggleEventCastMessageActive = async (eventId, messageId) => {
  try {
    const res = await axios.put(
      `${apiUrl}/${eventId}/cast/messages/toggle/${messageId}`,
      {},
      authHeaders()
    );
    return res.data;
  } catch (error) {
    console.error("toggleEventCastMessageActive error:", error);
  }
};

/// DELETE
// Supprimer un tapis (et ses slots)
export const deleteEventMat = async (eventId, matNumber) => {
  try {
    const res = await axios.delete(
      `${apiUrl}/${eventId}/cast/mats/${matNumber}`,
      authHeaders()
    );
    return res.data;
  } catch (error) {
    console.error("deleteEventMat error:", error);
  }
};

// Supprimer un message
export const deleteEventCastMessage = async (eventId, messageId) => {
  try {
    const res = await axios.delete(
      `${apiUrl}/${eventId}/cast/messages/delete/${messageId}`,
      authHeaders()
    );
    return res.data;
  } catch (error) {
    console.error("deleteEventCastMessage error:", error);
  }
};
